import {
  loadOfferByIdNonMfaCustomersService,
  loadOffersForNonMfaCustomersService,
  loadOffersService,
  loadPersonalOffersService,
  submitOffersService,
  updateCustomerPersonalOfferStatusService,
  getOtpForNonMFAUser,
  verifyOtpForNonMFAUser,
  storeTokenInSessionStorage,
  removeTokenFromSessionStorage,
  uploadFileinS3,
  loadPreviouslySubmittedNonMFAoffers,
  getDeviceTokenForUser,
  persistConsentService,
  updateNonMfaWhatsAppOptInService,
  getNonMfaUserProfileService,
} from './offers.service';
import {
  getCustomerId,
  getPersonalOfferData,
  getNonMfaUserPhoneNumber,
  getNonMfaUserSelectedOffer,
  getActiveContract,
  getAllAvailableOffersForMFACustomer,
} from './selectors';

import {postAPICall} from '../../services/apiCallsHandler';
import {
  PAGE_ACTION,
  logPageActionToNewRelic,
  setSubmittedOffersIdInSession,
  validateToken,
} from '../../utils/util';
import {
  LOAD_OFFERS_FOR_MFA_CUSTOMER,
  LOAD_PERSONAL_OFFER_LETTER_DATA,
  MFA_CUSTOMER_SUBMIT_OFFER_ENQUIRY,
  SET_OFFERS_FOR_MFA_CUSTOMER,
  SET_OFFERS_LOADING,
  SET_PERSONAL_OFFERS_LETTER_LOADING,
  SET_PERSONAL_OFFERS_LETTER_DATA,
  SUBMIT_RECOMMENDED_IMPLEMENT_ENQUIRY,
  SET_SHOW_HIDE_PERSONAL_OFFER_LETTER,
  SET_USER_SEEN_THE_PERSONAL_OFFER,
  SET_USER_SCRATCH_THE_PERSONAL_OFFER_CARD,
  SET_USER_ENQUIRE_THE_PERSONAL_OFFER_CARD,
  UPDATE_USER_SCRATCH_THE_CARD,
  VERIFY_OTP_NON_MFA_USER,
  GET_OTP_NON_MFA_USER,
  FETCH_NON_MFA_USER_PROFILE,
  UPDATE_NON_MFA_WHATSAPP_OPTIN,
  SET_NON_MFA_USER_MOBILE_NUMBER,
  SET_NON_MFA_ALERT,
  RESET_NON_MFA_ALERT,
  NON_MFA_USER_VERIFICATION_SUCCESS,
  LOAD_OFFERS_FOR_NON_MFA_CUSTOMER,
  SET_OFFERS_FOR_MFA_NON_CUSTOMER,
  LOAD_OFFER_BY_ID_NON_MFA_CUSTOMER,
  SET_OFFER_FOUND_BY_ID,
  SET_NON_MFA_OFFERS_LOADING,
  NON_MFA_USER_SUBMIT_OFFER,
  SET_NON_MFA_USER_DATA,
  SET_CUSTOM_ALERT,
  SET_OFFERS_VIEW,
  LOAD_PREVIOUS_SUBMITTED_OFFERS_NON_MFA,
  SET_PREVIOUS_SUBMITTED_OFFERS_NON_MFA,
  LOAD_USER_DEVICE_PUSH_TOKEN,
  ASK_USER_TO_ENABLE_PUSH,
  SET_OFFERS_SUBMIT,
} from '../actions';
import {FETCH_PROFILE_SUCCESS} from '../reducers/nonMfaProfileReducer';

import {call, put, select, takeEvery} from 'redux-saga/effects';

export function* loadOffersForMfaCustomers() {
  let offersLoading = true;
  yield put({type: SET_OFFERS_LOADING, offersLoading});
  const customerId = yield select(getCustomerId);

  const allOffersAvailableForMFACustomer = yield loadOffersService(customerId);

  yield put({
    type: SET_OFFERS_FOR_MFA_CUSTOMER,
    allOffersAvailableForMFACustomer,
  });

  offersLoading = false;
  yield put({type: SET_OFFERS_LOADING, offersLoading});
}

export function* loadOffersForNonMfaCustomers({data}) {
  let offersLoading = true;
  yield put({type: SET_NON_MFA_OFFERS_LOADING, offersLoading});
  const NoOfferFound = false;

  yield put({
    type: SET_OFFER_FOUND_BY_ID,
    NoOfferFound,
  });
  const allOffersAvailableForNonMFACustomer =
    yield loadOffersForNonMfaCustomersService(data);

  yield put({
    type: SET_OFFERS_FOR_MFA_NON_CUSTOMER,
    allOffersAvailableForNonMFACustomer,
  });

  offersLoading = false;
  yield put({type: SET_NON_MFA_OFFERS_LOADING, offersLoading});
}

export function* loadOffersForNonMfaCustomersById({data}) {
  let offersLoading = true;
  yield put({type: SET_OFFERS_LOADING, offersLoading});

  const allOffersAvailableForNonMFACustomer =
    yield loadOfferByIdNonMfaCustomersService(data);
  if (allOffersAvailableForNonMFACustomer.length > 0) {
    yield put({
      type: SET_OFFERS_FOR_MFA_NON_CUSTOMER,
      allOffersAvailableForNonMFACustomer,
    });
  } else {
    const NoOfferFound = true;
    yield put({
      type: SET_OFFER_FOUND_BY_ID,
      NoOfferFound,
    });
  }

  offersLoading = false;
  yield put({type: SET_OFFERS_LOADING, offersLoading});
}

export function* updatePersonalizedOfferEnquiry() {
  const customerId = yield select(getCustomerId);
  let personalOfferLetterData = yield loadPersonalOffersService(customerId);
  personalOfferLetterData = {
    userEnquireTheOffer: true,
    ...personalOfferLetterData[personalOfferLetterData.length - 1],
  };
  yield put({
    type: SET_PERSONAL_OFFERS_LETTER_DATA,
    personalOfferLetterData,
  });
}

export function* mfaCustomerSubmitOfferEnquiry(data) {
  let offersLoading = true;
  yield put({type: SET_OFFERS_SUBMIT, data: 'started'});
  yield put({type: SET_OFFERS_LOADING, offersLoading});

  const customerId = yield select(getCustomerId);
  let activeContract = yield select(getActiveContract);
  const offerData = {};
  offerData.offerId = data.data.selectedOffer.offerId;
  offerData.source = 'mfa';
  offerData.offerType = data.data.selectedOffer.offerType;
  offerData.offerName = data.data.selectedOffer.offerName;
  offerData.loanId = data.data.selectedOffer?.loanId;
  offerData.tbe = data.data.selectedOffer.abm;
  offerData.areaOffice = data.data.selectedOffer.areaOffice;
  offerData.abm = data.data.selectedOffer.tbe;
  const payload = {
    customerId: customerId,
    contractNumber:
      data.data?.selectedOffer?.contractId || activeContract?.contractNumber,
    ...data.data.enquiryData,
    ...offerData,
  };

  data.data.fileUploadData && uploadFileinS3(data.data.fileUploadData);

  const submitOfferResponse = yield submitOffersService(payload);
  const resp = submitOfferResponse;
  if (resp.success) {
    if (offerData.offerType === 'personalized') {
      yield updatePersonalizedOfferEnquiry();
    }
    logPageActionToNewRelic(PAGE_ACTION.OFFER_ENQUIRY_SUBMITTED, {
      isNonMfa: 'MFA',
      offerId: offerData.offerId,
      offerName: offerData.offerName,
    });
    const message = {
      alertVariant: 'success',
      type: 'offerSubmitted',
      showAlert: true,
    };
    if (data?.data?.showCustomAlert !== false) {
      yield put({type: SET_CUSTOM_ALERT, message});
    }
    let allOffersAvailableForMFACustomer = yield select(
      getAllAvailableOffersForMFACustomer
    );
    let filteredData = allOffersAvailableForMFACustomer.offersAvailable.filter(
      (offer) => {
        let nonSubmittedOffer;
        if (offer.loanId) {
          nonSubmittedOffer = offer.loanId !== offerData.loanId;
        } else {
          nonSubmittedOffer = offer.offerId !== offerData.offerId;
        }
        return nonSubmittedOffer;
      }
    );

    payload.timestamp = new Date();
    allOffersAvailableForMFACustomer = {
      ...allOffersAvailableForMFACustomer,
      offersAvailable: filteredData,
      previouslySubmittedOffers: [
        payload,
        ...allOffersAvailableForMFACustomer.previouslySubmittedOffers,
      ],
    };
    yield put({
      type: SET_OFFERS_FOR_MFA_CUSTOMER,
      allOffersAvailableForMFACustomer,
    });
    yield call(manageAlert, {
      alertVariant: 'success',
      type: 'submitSuccess',
    });
  } else {
    logPageActionToNewRelic(PAGE_ACTION.OFFER_ENQUIRY_ERROR, {
      isNonMfa: 'MFA',
      errorCode: '500',
    });
    const message = {
      alertVariant: 'danger',
      type: 'offerSubmitFail',
      showAlert: true,
    };
    yield put({type: SET_CUSTOM_ALERT, message});
    if (response.data === 'REQUEST_ALREADY_SUBMIT') {
      yield call(manageAlert, {
        alertVariant: 'danger',
        type: 'submitFailAlreadySubmitted',
      });
    } else {
      yield call(manageAlert, {
        alertVariant: 'danger',
        type: 'somethingWentWrong',
      });
    }
  }
  offersLoading = false;
  const viewName = 'offers';

  yield put({type: SET_OFFERS_VIEW, viewName});
  yield put({type: SET_OFFERS_SUBMIT, data: 'completed'});

  yield put({type: SET_OFFERS_LOADING, offersLoading});
}
export function* loadPersonalOfferLetter({data}) {
  const oktaAuth = data;
  let personalOfferLetterLoading = true;
  yield put({
    type: SET_PERSONAL_OFFERS_LETTER_LOADING,
    personalOfferLetterLoading,
  });
  let customerId = yield select(getCustomerId);

  if (!customerId) {
    const userDetails = yield oktaAuth.getUser();
    customerId = userDetails.preferred_username;
  }

  let personalOfferLetterData = yield loadPersonalOffersService(customerId);
  let showCard = false;
  if (personalOfferLetterData && personalOfferLetterData.length > 0) {
    showCard = true;
    if (
      personalOfferLetterData[personalOfferLetterData.length - 1]
        .userEnquireTheOffer ||
      personalOfferLetterData[personalOfferLetterData.length - 1]
        .userScratchTheCard
    ) {
      showCard = false;
    }
    personalOfferLetterData = {
      showCard: showCard,
      ...personalOfferLetterData[personalOfferLetterData.length - 1],
    };

    yield put({
      type: SET_PERSONAL_OFFERS_LETTER_DATA,
      personalOfferLetterData,
    });
  }

  personalOfferLetterLoading = false;
  yield put({
    type: SET_PERSONAL_OFFERS_LETTER_LOADING,
    personalOfferLetterLoading,
  });
}

export function* submitImplementRequest(data) {
  let payload = {};
  const customerId = yield select(getCustomerId);
  const customerData = yield select(getPersonalOfferData);
  const dateObj = new Date();
  const offerId = `${dateObj.getMonth() + 1}${dateObj.getFullYear()}_P`;
  payload = {
    offerId: offerId,
    source: 'mfa',
    offerType: 'personalized',
    offerName: customerData.implement,
    tbe: customerData.tbe_racf,
    abm: customerData.abm_racf,
    contractNumber: customerData.contractNumber,
    customerId: customerId,
    areaOffice: customerData.AO,
    ...data.data,
  };
  const submitOfferResponse = yield submitOffersService(payload);
  const resp = submitOfferResponse;
  if (resp.success) {
    logPageActionToNewRelic(PAGE_ACTION.SPECIAL_OFFER_SUBMITTED, {
      isNonMfa: 'MFA',
      offerId: offerId,
      offerName: payload.offerName,
    });
    yield updatePersonalizedOfferEnquiry();
    const message = {
      alertVariant: 'success',
      type: 'offerSubmitted',
      showAlert: true,
    };
    yield put({type: SET_CUSTOM_ALERT, message});
    yield loadOffersForMfaCustomers();
  } else {
    const message = {
      alertVariant: 'danger',
      type: 'offerSubmitFail',
      showAlert: true,
    };
    yield put({type: SET_CUSTOM_ALERT, message});
  }

  const showPersonalOfferCard = false;
  yield put({
    type: SET_SHOW_HIDE_PERSONAL_OFFER_LETTER,
    showPersonalOfferCard,
  });
}
export function* loadPreviouslySubmittedOfferNonMFA() {
  let offersLoading = true;
  yield put({type: SET_NON_MFA_OFFERS_LOADING, offersLoading});
  let userPhoneNumber = yield select(getNonMfaUserPhoneNumber);

  if (!userPhoneNumber) {
    userPhoneNumber = sessionStorage.getItem('phoneNumber');
  }
  const {data} = yield loadPreviouslySubmittedNonMFAoffers();

  yield put({
    type: SET_PREVIOUS_SUBMITTED_OFFERS_NON_MFA,
    data,
  });
  offersLoading = false;
  yield put({type: SET_NON_MFA_OFFERS_LOADING, offersLoading});
}

export function* updateUserPersonalOfferStatus({data}) {
  let payload = {};
  const customerId = yield select(getCustomerId);

  payload = {
    userSeenPersonalOffer: data.seenPersonalOffer,
    userScratchTheCard: data.userScratchTheCard,
    userEnquireTheOffer: data.userEnquireTheOffer,
  };

  yield updateCustomerPersonalOfferStatusService(customerId, payload);
  if (data.userScratchTheCard === true) {
    yield put({
      type: UPDATE_USER_SCRATCH_THE_CARD,
      userScratchTheCard: true,
    });
  }
}

export function* loadDeviceTokenForUser({customerId}) {
  let checkForToken = false;
  const lastAskedForConfirmation = localStorage.getItem('lastAsked');
  if (
    lastAskedForConfirmation &&
    new Date().getTime() - lastAskedForConfirmation > 2505600000
  ) {
    checkForToken = true;
    localStorage.setItem('lastAsked', new Date().getTime());
  } else if (!lastAskedForConfirmation) {
    checkForToken = true;
    localStorage.setItem('lastAsked', new Date().getTime());
  }
  if (checkForToken) {
    const deviceToken = yield getDeviceTokenForUser(customerId);
    if (deviceToken.length < 1) {
      yield put({
        type: ASK_USER_TO_ENABLE_PUSH,
        data: true,
      });
      logPageActionToNewRelic(PAGE_ACTION.NOTIFICATION_ASKED_CONFIRMATION, {});
    } else {
      logPageActionToNewRelic(PAGE_ACTION.NOTIFICATION_ALREADY_ENABLE, {});
      yield put({
        type: ASK_USER_TO_ENABLE_PUSH,
        data: false,
      });
    }
  }
}

export function* loadOffers() {
  yield takeEvery(LOAD_OFFERS_FOR_MFA_CUSTOMER, loadOffersForMfaCustomers);
  yield takeEvery(
    LOAD_OFFERS_FOR_NON_MFA_CUSTOMER,
    loadOffersForNonMfaCustomers
  );
  yield takeEvery(
    LOAD_OFFER_BY_ID_NON_MFA_CUSTOMER,
    loadOffersForNonMfaCustomersById
  );

  yield takeEvery(LOAD_PERSONAL_OFFER_LETTER_DATA, loadPersonalOfferLetter);
  yield takeEvery(SUBMIT_RECOMMENDED_IMPLEMENT_ENQUIRY, submitImplementRequest);
  yield takeEvery(
    SET_USER_SEEN_THE_PERSONAL_OFFER,
    updateUserPersonalOfferStatus
  );
  yield takeEvery(
    SET_USER_SCRATCH_THE_PERSONAL_OFFER_CARD,
    updateUserPersonalOfferStatus
  );
  yield takeEvery(
    SET_USER_ENQUIRE_THE_PERSONAL_OFFER_CARD,
    updateUserPersonalOfferStatus
  );

  yield takeEvery(
    MFA_CUSTOMER_SUBMIT_OFFER_ENQUIRY,
    mfaCustomerSubmitOfferEnquiry
  );
  yield takeEvery(
    LOAD_PREVIOUS_SUBMITTED_OFFERS_NON_MFA,
    loadPreviouslySubmittedOfferNonMFA
  );
  yield takeEvery(LOAD_USER_DEVICE_PUSH_TOKEN, loadDeviceTokenForUser);
}

export const duration = (delay) =>
  new Promise((resolve) => setTimeout(resolve, delay));

export function* manageAlert(params) {
  let message = {...params, showAlert: true};
  yield put({type: SET_NON_MFA_ALERT, message});
  yield call(duration, 5000);
  yield put({type: RESET_NON_MFA_ALERT});
}

export function* getNonMfaOtp({phoneNumber}) {
  yield put({
    type: SET_NON_MFA_USER_MOBILE_NUMBER,
    phoneNumber,
  });
  const payload = {phoneNumber: `91${phoneNumber}`};
  const res = yield getOtpForNonMFAUser(payload);
  if (res.statusCode === 200) {
    yield call(manageAlert, {
      alertVariant: 'success',
      type: 'otpSuccess',
    });
  } else if (res.statusCode === 400 && res.data === 'OTP Already Send') {
    yield call(manageAlert, {
      alertVariant: 'warning',
      type: 'otpAlreadySent',
    });
  } else {
    yield call(manageAlert, {
      alertVariant: 'danger',
      type: 'otpFailure',
    });
  }
  removeTokenFromSessionStorage();
}

export function* verifyNonMfaOtp({otp}) {
  const phoneNumber = yield select(getNonMfaUserPhoneNumber);
  const payload = {
    phoneNumber: `91${phoneNumber}`,
    otp: otp,
  };

  const res = yield verifyOtpForNonMFAUser(payload);
  if (
    res.statusCode === 200 &&
    res?.data?.token &&
    validateToken(res.data.token, payload.phoneNumber)
  ) {
    const sessionData = {
      nonMFAToken: res.data.token,
      nonMFATokenExpiry: new Date().getTime() + 60 * 60 * 1000,
    };
    storeTokenInSessionStorage(sessionData);
    yield put({
      type: NON_MFA_USER_VERIFICATION_SUCCESS,
    });
  } else if (res.statusCode === 400 && res.data === 'Invalid OTP') {
    yield call(manageAlert, {
      alertVariant: 'warning',
      type: 'wrongOtp',
    });
  } else if (res.statusCode === 400 && res.data === 'Invalid request') {
    yield call(manageAlert, {
      alertVariant: 'warning',
      type: 'invalidOtp',
    });
  } else {
    yield call(manageAlert, {
      alertVariant: 'danger',
      type: 'otpFailure',
    });
  }
}

export function* submitOfferNonMfaUser({data}) {
  let offerId;
  let offerName = '';
  const states = sessionStorage.getItem('offer_state');
  const selectedOffer = yield select(getNonMfaUserSelectedOffer);
  offerId = selectedOffer.offerId;
  offerName = selectedOffer.offerName;
  const payload = {
    offerId,
    states,
    offerName,
  };
  delete payload.phoneNumber;
  let response = yield call(
    postAPICall,
    '/submitNonMfaCustomerOffer',
    payload,
    {
      isCallBack: true,
      errorTag: 'SUBMIT_NON_MFA_USER_OFFER',
      logInfoMsg: 'submitting non mfa user offer',
      redirectToOops: false,
    }
  );
  if (response.statusCode === 200) {
    logPageActionToNewRelic(PAGE_ACTION.OFFER_ENQUIRY_SUBMITTED, {
      isNonMfa: 'NON-MFA',
      offerId: offerId,
      offerName: payload.offerName,
    });
    const userdata = {
      ...data,
      enquirySubmitted: true,
    };
    setSubmittedOffersIdInSession(offerId);
    yield put({
      type: SET_NON_MFA_USER_DATA,
      data: userdata,
    });
    yield call(manageAlert, {
      alertVariant: 'success',
      type: 'submitSuccess',
    });
  } else {
    logPageActionToNewRelic(PAGE_ACTION.OFFER_ENQUIRY_ERROR, {
      isNonMfa: 'NON-MFA',
      errorCode: 500,
    });
    yield call(manageAlert, {
      alertVariant: 'danger',
      type: 'otpFailure',
    });
  }
}

export function* fetchNonMfaProfile() {
  const profileResponse = yield getNonMfaUserProfileService();
  if (typeof profileResponse?.isMfaUser === 'boolean') {
    yield put({
      type: FETCH_PROFILE_SUCCESS,
      payload: profileResponse,
    });
  }
}

export function* updateNonMfaWhatsAppOptIn({optIn}) {
  try {
    yield call(updateNonMfaWhatsAppOptInService, optIn);
  } catch (e) {
    yield call(manageAlert, {
      alertVariant: 'danger',
      type: 'somethingWentWrong',
    });
  }
}

export function* authenticateNonMfaUser() {
  yield takeEvery(GET_OTP_NON_MFA_USER, getNonMfaOtp);
  yield takeEvery(VERIFY_OTP_NON_MFA_USER, verifyNonMfaOtp);
  yield takeEvery(NON_MFA_USER_SUBMIT_OFFER, submitOfferNonMfaUser);
  yield takeEvery(FETCH_NON_MFA_USER_PROFILE, fetchNonMfaProfile);
  yield takeEvery(UPDATE_NON_MFA_WHATSAPP_OPTIN, updateNonMfaWhatsAppOptIn);
}
